import type {
  AnalyticsResumeAlertPosition,
  AnalyticsResumeAlertShownMessage,
  AnalyticsResumeAlertShownTone,
  AnalyticsResumeAlertShownType,
  AnalyticsResumeAlertTitle,
} from 'src/modules/analytics/types';

export const PROFILE_RESUME_DEFAULT_WITH_ALERT_LOADED =
  'PROFILE_RESUME_DEFAULT_WITH_ALERT_LOADED';

type Props = {
  alertShownType: AnalyticsResumeAlertShownType;
  alertShownTone: AnalyticsResumeAlertShownTone;
  alertShownPosition: AnalyticsResumeAlertPosition;
  alertShownTitle: AnalyticsResumeAlertTitle;
  alertShownMessage: AnalyticsResumeAlertShownMessage;
};

export const resumeDefaultAlertLoaded = ({
  alertShownType,
  alertShownTone,
  alertShownPosition,
  alertShownTitle,
  alertShownMessage,
}: Props) => ({
  type: PROFILE_RESUME_DEFAULT_WITH_ALERT_LOADED,
  payload: {
    alertShownType,
    alertShownTone,
    alertShownPosition,
    alertShownTitle,
    alertShownMessage,
  },
});
